






























































import { Component, Vue } from "vue-property-decorator";

import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VCheckbox from "@/components/VCheckbox.vue";
import SelectOption from "@/interfaces/SelectOption";

@Component({
  components: {
    VMultiSwitcher,
    VCheckbox,
  },
})
export default class FormControls extends Vue {
  protected multiSwitcherItems: Array<SelectOption> = [
    { id: "first", text: "Primo" },
    { id: "second", text: "Secondo" },
    { id: "third", text: "Terzo" },
  ];
  protected multiSwitcherIconItems: Array<SelectOption> = [
    { id: "bar", text: "bar-chart" },
    { id: "line", text: "line-chart" },
    { id: "pie", text: "pie-chart" },
  ];
  protected multiSwitcherValue = "first";
  protected multiSwitcherIconValue = "bar";
  protected check = false;
}
